import { styled } from '@mui/material/styles';

import { Footer } from '../../molecules/MainWithFooterTemplate';

export const FooterStyled = styled(Footer)(({ theme }) => ({
	[theme.breakpoints.up('tabletP')]: {
		display: 'flex',
		flex: '1 1 50%',
		gap: 24,
	},
}));

export const FooterWrapper = styled('div')(({ theme }) => ({
	[theme.breakpoints.down('tabletP')]: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',

		'& .cancelButton': {
			width: 'auto',
		},
	},
}));
